import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Product } from '../../models/product.model';
import { ProductService } from '../../services/product.service';

@Component({
  selector: 'app-product-card',
  imports: [CommonModule, RouterLink],
  templateUrl: './product-card.component.html',
  styleUrl: './product-card.component.scss'
})
export class ProductCardComponent {
  @Input({ required: true }) product!: Product;

  constructor(private productService: ProductService) {}

  get isInStock(): boolean {
    return this.productService.isInStock(this.product);
  }

  get hasLowStock(): boolean {
    return this.productService.hasLowStock(this.product);
  }

  get stockBadgeText(): string {
    if (!this.isInStock) return 'Fora de Estoque';
    if (this.hasLowStock) return 'Últimas Unidades!';
    return 'Em Estoque';
  }

  get stockBadgeClass(): string {
    if (!this.isInStock) return 'badge-out-of-stock';
    if (this.hasLowStock) return 'badge-low-stock';
    return 'badge-stock';
  }

  formatPrice(price: number): string {
    return price.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  get vehicleText(): string {
    if (this.product.veiculoCompativel.length === 0) return '';
    const first = this.product.veiculoCompativel[0];
    return `${first.marca} ${first.modelo} ${first.anoInicio}-${first.anoFim}`;
  }
}

